"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Text = _interopRequireDefault(require("../Text"));
var _Checkbox = _interopRequireDefault(require("../Checkbox"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Image = _interopRequireDefault(require("../Image"));
var _constants = require("./constants");
var _checklist = _interopRequireDefault(require("./checklist.proptypes"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ChecklistContainer = _styledComponents.default.div.withConfig({
  displayName: "Checklist__ChecklistContainer",
  componentId: "sc-w0k9kr-0"
})([""]);
var ChecklistList = _styledComponents.default.ul.withConfig({
  displayName: "Checklist__ChecklistList",
  componentId: "sc-w0k9kr-1"
})(function (_ref) {
  var isFlexBoxOrientation = _ref.isFlexBoxOrientation;
  return "\n    padding: 0;\n    list-style: none;\n    margin: 0;\n    position: relative;\n    ".concat(isFlexBoxOrientation ? "\n        display: flex;\n        flex-direction: row;\n        flex-wrap: wrap;\n        column-gap: 2rem;\n      " : '', "\n  ");
});
var CheckListItem = _styledComponents.default.li.withConfig({
  displayName: "Checklist__CheckListItem",
  componentId: "sc-w0k9kr-2"
})(function (_ref2) {
  var theme = _ref2.theme,
    isReversed = _ref2.isReversed,
    isFullWidth = _ref2.isFullWidth,
    isIndentItem = _ref2.isIndentItem,
    customProperties = _ref2.customProperties,
    isMobile = _ref2.isMobile;
  return "\n    display: flex;\n    cursor: ".concat(isMobile ? '' : 'pointer', ";\n    ").concat(customProperties && customProperties !== null && customProperties !== void 0 && customProperties.bottomMargin ? "margin-bottom: ".concat(theme.space[customProperties.bottomMargin]) : "margin-bottom: ".concat(theme.space.standard, ";"), ";\n\n        & .check-box {\n            margin: 0;\n        }\n    div {\n      ").concat(isReversed ? "\n          order: 2;\n        " : '', "\n    }\n\n    p {\n      ").concat(isReversed ? "\n          order: 1;\n          ".concat(isFullWidth && 'width: 100%', "\n        ") : '', "\n    }\n    ").concat(isIndentItem ? " margin-left: 10px;" : "", "\n    ");
});
var CheckListOverlay = _styledComponents.default.div.withConfig({
  displayName: "Checklist__CheckListOverlay",
  componentId: "sc-w0k9kr-3"
})(["position:absolute;bottom:23px;width:100%;height:50px;background:linear-gradient(180deg,rgba(255,255,255,0) 0%,#ffffff 45%,#ffffff 100%);z-index:1;"]);
var TextContainer = _styledComponents.default.div.withConfig({
  displayName: "Checklist__TextContainer",
  componentId: "sc-w0k9kr-4"
})(function (_ref3) {
  var withImage = _ref3.withImage,
    theme = _ref3.theme;
  return "\n    ".concat(withImage ? "padding-left: ".concat(theme.space.micro, "; display:flex; align-items: center") : "", ";\n  ");
}, function (_ref4) {
  var withCode = _ref4.withCode;
  return "\n  ".concat(withCode && "margin-left: auto", ";\n");
});
var ShowMoreContainer = _styledComponents.default.div.withConfig({
  displayName: "Checklist__ShowMoreContainer",
  componentId: "sc-w0k9kr-5"
})(["cursor:", ";"], function (_ref5) {
  var isMobile = _ref5.isMobile;
  return isMobile ? '' : 'pointer';
});
var IconContainer = _styledComponents.default.div.withConfig({
  displayName: "Checklist__IconContainer",
  componentId: "sc-w0k9kr-6"
})(["display:flex;align-items:center;"]);
var Checklist = function Checklist(props) {
  var title = props.title,
    data = props.data,
    onListSelection = props.onListSelection,
    initialShownItem = props.initialShownItem,
    showMoreText = props.showMoreText,
    showMoreIcon = props.showMoreIcon,
    accessible = props.accessible,
    theme = props.theme,
    isReversed = props.isReversed,
    isFullWidth = props.isFullWidth,
    customProperties = props.customProperties,
    showLessBtn = props.showLessBtn,
    showLessText = props.showLessText,
    isIndentItem = props.isIndentItem,
    isTextBold = props.isTextBold,
    textType = props.textType,
    bottomOverlay = props.bottomOverlay,
    onSeeMoreClicked = props.onSeeMoreClicked,
    onSeeLessClicked = props.onSeeLessClicked,
    showMoreTextColor = props.showMoreTextColor,
    isShowMoreTextBold = props.isShowMoreTextBold,
    withImage = props.withImage,
    isFlexBoxOrientation = props.isFlexBoxOrientation,
    isMobile = props.isMobile,
    withCode = props.withCode,
    activeColor = props.activeColor,
    showLessIcon = props.showLessIcon;
  var _useState = (0, _react.useState)(data),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    checklistData = _useState2[0],
    setChecklistData = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    startIndexToHide = _useState4[0],
    setStartIndexToHide = _useState4[1];
  var tabIndex = !accessible ? '-1' : '0';
  var checkItemVisibility = (0, _react.useCallback)(function () {
    if (initialShownItem == null) {
      setStartIndexToHide(null);
    } else if (data.length !== initialShownItem) {
      setStartIndexToHide(initialShownItem - 1);
    } else {
      setStartIndexToHide(null);
    }
  }, [data.length, initialShownItem]);
  (0, _react.useEffect)(function () {
    setChecklistData(data);
  }, [data]);
  (0, _react.useEffect)(function () {
    checkItemVisibility();
  }, [initialShownItem, data, checkItemVisibility]);
  (0, _react.useEffect)(function () {
    checkItemVisibility();
  }, [checkItemVisibility]);
  var onCheckHandler = function onCheckHandler(e, index) {
    var dataCopy = (0, _toConsumableArray2.default)(checklistData);
    dataCopy[index].isChecked = !dataCopy[index].isChecked;
    var selectedItems = dataCopy.filter(function (dc) {
      return dc.isChecked;
    });
    onListSelection(selectedItems);
    setChecklistData(dataCopy);
  };
  var handleOnKeyPress = function handleOnKeyPress(e, index) {
    if (e.key === 'Enter' || e.key === 'NumpadEnter') {
      onCheckHandler(e, index);
    }
  };
  var showMoreHandler = function showMoreHandler() {
    setStartIndexToHide(null);
    if (onSeeMoreClicked) onSeeMoreClicked();
  };
  var showLessHandler = function showLessHandler() {
    checkItemVisibility();
    if (onSeeLessClicked) onSeeLessClicked();
  };
  var _ref6 = customProperties || {},
    titleProperties = _ref6.titleProperties;
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(ChecklistContainer, customProperties, title && /*#__PURE__*/_react.default.createElement(_Text.default, {
      customProperties: titleProperties,
      marginBottom: "normal",
      color: "greyDarker",
      bold: true,
      theme: theme,
      accessible: accessible
    }, title), /*#__PURE__*/_react.default.createElement(ChecklistList, {
      isFlexBoxOrientation: isFlexBoxOrientation
    }, checklistData.map(function (d, index) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null,
      // eslint-disable-next-line no-nested-ternary
      startIndexToHide == null || index <= startIndexToHide ? /*#__PURE__*/_react.default.createElement(CheckListItem, {
        isReversed: isReversed,
        isMobile: isMobile,
        isFullWidth: isFullWidth,
        isIndentItem: isIndentItem,
        tabIndex: tabIndex,
        onClick: function onClick(e) {
          return onCheckHandler(e, index);
        },
        onKeyPress: function onKeyPress(e) {
          return handleOnKeyPress(e, index);
        },
        customProperties: customProperties
      }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
        isReversed: isReversed,
        isFullWidth: isFullWidth,
        isSelected: d.isChecked,
        accessible: false,
        activeColor: activeColor
      }), withImage && /*#__PURE__*/_react.default.createElement(_Image.default, {
        accessible: true,
        centerFocus: true,
        enableProgressiveImageLoading: false,
        height: "24px",
        lazyLoadImage: false,
        placeHolderBackground: "tertiary",
        radius: "",
        src: d.imageURL,
        theme: theme,
        type: "FLIGHT",
        width: "24px"
      }), /*#__PURE__*/_react.default.createElement(TextContainer, {
        withImage: withImage
      }, /*#__PURE__*/_react.default.createElement(_Text.default, {
        bold: isTextBold,
        type: textType,
        accessible: false,
        theme: theme
      }, d.text)), withCode && /*#__PURE__*/_react.default.createElement(TextContainer, {
        withCode: withCode
      }, /*#__PURE__*/_react.default.createElement(_Text.default, {
        bold: isTextBold,
        type: textType,
        accessible: false,
        theme: theme,
        color: _constants.VALUE_COLOR
      }, d.value))) : null, startIndexToHide !== null && index === startIndexToHide ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, bottomOverlay && /*#__PURE__*/_react.default.createElement(CheckListOverlay, null), /*#__PURE__*/_react.default.createElement(CheckListItem, {
        customProperties: customProperties
      }, /*#__PURE__*/_react.default.createElement(ShowMoreContainer, {
        isMobile: isMobile,
        onClick: showMoreHandler
      }, /*#__PURE__*/_react.default.createElement(_Text.default, {
        type: textType,
        color: showMoreTextColor || 'blue',
        theme: theme,
        bold: isShowMoreTextBold
      }, showMoreText, showMoreIcon && /*#__PURE__*/_react.default.createElement(IconContainer, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        theme: theme,
        accessible: accessible,
        color: showMoreTextColor || 'secondary',
        fontsize: "titleSmall",
        padding: "0 0 0 5px",
        icon: "ExpandMoreIcon"
      })))))) : null);
    })), showLessBtn && startIndexToHide === null && /*#__PURE__*/_react.default.createElement(CheckListItem, {
      customProperties: customProperties
    }, /*#__PURE__*/_react.default.createElement(ShowMoreContainer, {
      onClick: showLessHandler
    }, /*#__PURE__*/_react.default.createElement(_Text.default, {
      type: textType,
      theme: theme,
      color: showMoreTextColor || 'blue',
      bold: isShowMoreTextBold
    }, showLessText, showLessIcon && /*#__PURE__*/_react.default.createElement(IconContainer, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      theme: theme,
      accessible: accessible,
      color: showMoreTextColor || 'secondary',
      fontsize: "titleSmall",
      padding: "0 0 0 5px",
      icon: "ExpandLessIcon"
    }))))));
  };
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
Checklist.propTypes = _checklist.default.PropTypes;
Checklist.defaultProps = _checklist.default.DefaultProps;
var _default = Checklist;
exports.default = _default;